import React from 'react';
import { useWallet } from '../hooks/useWallet';

const proposals = [
  {
    id: 'PROP-003',
    title: 'Tokenize Sovereign Reserve NCD-001 and Seed AMTS/NCD Pool',
    desc: 'Approve tokenization of $100M sovereign NCD on Amitis. Allocate 13,333,333 AMTS from liquidity reserve to seed the primary AMTS/NCD pool at $7.50. NCD yield donated to community pool.',
    status: 'voting',
    statusLabel: 'Voting',
    yes: 72, no: 8, abs: 20,
    ends: 'Ends in 18h 42m',
  },
  {
    id: 'PROP-002',
    title: 'Fund Fiat Service Provider — Q2 2026 Operating Budget',
    desc: 'Allocate 2,500 USDC from community pool to multisig for Q2 fiat operational expenses including domain registrations, legal correspondence, and infrastructure.',
    status: 'passed',
    statusLabel: 'Passed',
    yes: 94, no: 2, abs: 4,
    ends: 'Passed · Block #741,102',
  },
  {
    id: 'PROP-001',
    title: 'Genesis Parameter Ratification — Amitis Network',
    desc: 'Ratify genesis parameters including 80% fee rebate, 21 fixed validator set, community pool allocation rate, and initial governance parameters.',
    status: 'passed',
    statusLabel: 'Passed',
    yes: 100, no: 0, abs: 0,
    ends: 'Passed · Genesis',
  },
];

const statusColors = {
  voting: 'badge-gold',
  passed: 'badge-green',
  failed: 'badge-muted',
};

export default function Governance() {
  const { address } = useWallet();

  function vote(prop, v) {
    if (!address) { alert('Connect wallet to vote'); return; }
    alert(`Voting ${v} on ${prop} — governance tx integration coming soon`);
  }

  return (
    <div className="page-content fade-up">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div>
          <span className="section-label">On-Chain Governance</span>
          <div style={{ fontSize: 22, fontWeight: 800 }}>Proposals</div>
        </div>
        <button className="btn btn-primary btn-sm">+ Submit Proposal</button>
      </div>

      {proposals.map(p => (
        <div className="prop-card" key={p.id}>
          <div className="prop-header">
            <div style={{ flex: 1 }}>
              <div className="prop-id">{p.id}</div>
              <div className="prop-title">{p.title}</div>
              <div className="prop-desc">{p.desc}</div>
            </div>
            <span className={`badge ${statusColors[p.status]}`} style={{ flexShrink: 0 }}>{p.statusLabel}</span>
          </div>

          <div className="vote-bar">
            <div className="vote-yes" style={{ width: `${p.yes}%` }}></div>
            <div className="vote-no"  style={{ width: `${p.no}%` }}></div>
            <div className="vote-abs" style={{ width: `${p.abs}%` }}></div>
          </div>
          <div className="vote-labels">
            <span style={{ color: 'var(--green)' }}>Yes {p.yes}%</span>
            <span>{p.ends}</span>
            <span style={{ color: 'var(--red)' }}>No {p.no}%</span>
          </div>

          {p.status === 'voting' && (
            <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
              <button className="btn btn-primary btn-sm" onClick={() => vote(p.id, 'yes')}>Vote Yes</button>
              <button
                className="btn btn-sm"
                style={{ background: 'var(--red-dim)', color: 'var(--red)', border: '1px solid rgba(248,113,113,0.25)' }}
                onClick={() => vote(p.id, 'no')}
              >
                Vote No
              </button>
              <button className="btn btn-outline btn-sm" onClick={() => vote(p.id, 'abstain')}>Abstain</button>
              <span style={{ marginLeft: 'auto', fontFamily: 'DM Mono, monospace', fontSize: 10, color: 'var(--dimmer)', alignSelf: 'center' }}>
                Voting power: {address ? '—' : 'Connect wallet'}
              </span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
